import type { SecondaryNavContextValue } from './types'
import React from 'react'

const defaultValue: SecondaryNavContextValue = {
  links: [],
  setLinks: () => {
    // do nothing by default
  },
}

const SecondaryNavContext = React.createContext<SecondaryNavContextValue>(defaultValue)

export default SecondaryNavContext
